// test2655
(2655 && 0);
